import { Component } from 'react';
import { isTrue } from '../../../helpers/isTrue';
import { COLUMNS } from './keys';
import { getSortKeys, setAdditionalStyles } from '../../../helpers/table';
import DataTable from '../../../components/Datatable';
import Message from '../../Message';
import CommerceSettingsModal from '../CommerceSettingsModal';
import { withTranslation } from 'react-i18next';

class CommerceView extends Component {
    constructor(props) {
        super();

        const items = JSON.parse(props.commerce_projects);

        this.onOpen = this.onOpen.bind(this);
        this.onClose = this.onClose.bind(this);
        this.updateItemQuiliers = this.updateItemQuiliers.bind(this);
        this.onOpenMessage = this.onOpenMessage.bind(this);
        this.deleteMessage = this.deleteMessage.bind(this);

        this.state = {
            isOpen: false,
            items,
        };
    }

    searchFunction(data, search) {
        if (!search) return data;
        return data.filter((item) => item?.keyword?.toLowerCase()?.includes(search.toLowerCase()));
    }

    onOpen(selectedItem) {
        this.setState({
            isOpen: true,
            selectedItem,
        });
    }

    onClose() {
        this.setState({
            isOpen: false,
            selectedItem: null,
        });
    }

    updateItemQuiliers({ qualifiers, project_id, own_domain }) {
        this.setState({
            items: this.state.items?.map((item) => {
                if (project_id === item.project_id) return { ...item, qualifiers, own_domain };
                return item;
            }),
        });
    }

    onOpenMessage(message, message_tag) {
        this.setState({
            message,
            message_tag: message_tag,
        });
    }

    deleteMessage() {
        this.setState({
            message: '',
            message_tag: '',
        });
    }

    render() {
        const { t } = this.props;

        const has_api_key = isTrue(this.props.has_api_key);
        return (
            <>
                <div className="d-flex justify-content-end mb-10">
                    <a
                        className="button button-filled button-primary width-sm btn d-flex align-items-center justify-content-center"
                        href="/commerce/create/"
                        style={has_api_key ? {} : { pointerEvents: 'none', opacity: 0.5 }}
                    >
                        {t('commerce.report.createProject')}
                    </a>
                </div>
                <div className="card rounded-main table-main">
                    {!has_api_key && (
                        <div className="card-body">
                            (
                            <div className="d-flex justify-content-between align-items-center">
                                {t('commerce.report.needApiKey')}
                                <a
                                    className="button button-filled button-primary width-sm btn d-flex align-items-center justify-content-center"
                                    href="/commerce/settings/"
                                >
                                    {t('commerce.report.addKey')}
                                </a>
                            </div>
                            )
                        </div>
                    )}
                    <div>
                        {this.state.items?.length !== 0 && (
                            <DataTable
                                nodes={this.state.items}
                                sortFns={getSortKeys(COLUMNS(t))}
                                COLUMNS={COLUMNS(t, this.onOpen)}
                                fileName={t('commerce.header')}
                                header={t('commerce.header')}
                                searchFunction={this.searchFunction}
                                uniqKey={'project_id'}
                                defaultSortKey={'created_at'}
                                additionalStyles={setAdditionalStyles(COLUMNS(t))}
                            />
                        )}
                    </div>
                </div>
                {this.state.isOpen && (
                    <CommerceSettingsModal
                        csrf_token={this.props.csrf_token}
                        isOpen={this.state.isOpen}
                        onClose={this.onClose}
                        selectedItem={this.state.selectedItem}
                        updateItemQuiliers={this.updateItemQuiliers}
                        onOpenMessage={this.onOpenMessage}
                        includeDomain
                    />
                )}
                {this.state.message && (
                    <div className="messages">
                        <Message
                            message_tags={this.state.message_tag}
                            message={this.state.message}
                            deleteMessage={this.deleteMessage}
                        />
                    </div>
                )}
            </>
        );
    }
}

export default withTranslation()(CommerceView);
